// src/api/organisme-paiement-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
export const GET_ORGANISMES_PAIEMENT = gql`
  query GetOrganismesPaiement {
    organismesPaiement {
      id
      nomOrganisme
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      defaultOrganisme
      paymentRequests {
        id
      }
      paramsPayments {
        id
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_ORGANISME_PAIEMENT = gql`
  query GetOrganismePaiement($id: ID!) {
    organismePaiement(id: $id) {
      id
      nomOrganisme
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      defaultOrganisme
      paymentRequests {
        id
        amount
        status
        dateDemande
        user {
          id
          firstName
          lastName
          email
        }
      }
      paramsPayments {
        id
        nom
        seuil
        numberOfDays
      }
      createdAt
      updatedAt
    }
  }
`;

// GraphQL Mutations
export const CREATE_ORGANISME_PAIEMENT = gql`
  mutation CreateOrganismePaiement($createOrganismePaiementInput: CreateOrganismePaiementInput!) {
    createOrganismePaiement(createOrganismePaiementInput: $createOrganismePaiementInput) {
      id
      nomOrganisme
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      defaultOrganisme
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ORGANISME_PAIEMENT = gql`
  mutation UpdateOrganismePaiement($updateOrganismePaiementInput: UpdateOrganismePaiementInput!) {
    updateOrganismePaiement(updateOrganismePaiementInput: $updateOrganismePaiementInput) {
      id
      nomOrganisme
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      defaultOrganisme
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_ORGANISME_PAIEMENT = gql`
  mutation RemoveOrganismePaiement($id: ID!) {
    removeOrganismePaiement(id: $id)
  }
`;

export const SET_DEFAULT_ORGANISME = gql`
  mutation SetDefaultOrganisme($id: ID!) {
    setDefaultOrganisme(id: $id) {
      id
      nomOrganisme
      defaultOrganisme
    }
  }
`;

// Organisme Paiement API functions
export const organismePaiementApi = {
  getOrganismesPaiement: async () => {
    try {
      const { data } = await client.query({
        query: GET_ORGANISMES_PAIEMENT,
        fetchPolicy: 'network-only'
      });
      return data.organismesPaiement;
    } catch (error) {
      console.error('Get organismes paiement error:', error);
      throw error;
    }
  },

  getOrganismePaiement: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_ORGANISME_PAIEMENT,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.organismePaiement;
    } catch (error) {
      console.error(`Get organisme paiement ${id} error:`, error);
      throw error;
    }
  },

  createOrganismePaiement: async (organismeData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_ORGANISME_PAIEMENT,
        variables: { createOrganismePaiementInput: organismeData },
        refetchQueries: [{ query: GET_ORGANISMES_PAIEMENT }]
      });
      return data.createOrganismePaiement;
    } catch (error) {
      console.error('Create organisme paiement error:', error);
      throw error;
    }
  },

  updateOrganismePaiement: async (organismeData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_ORGANISME_PAIEMENT,
        variables: { updateOrganismePaiementInput: organismeData },
        refetchQueries: [{ query: GET_ORGANISMES_PAIEMENT }]
      });
      return data.updateOrganismePaiement;
    } catch (error) {
      console.error(`Update organisme paiement ${organismeData.id} error:`, error);
      throw error;
    }
  },

  deleteOrganismePaiement: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_ORGANISME_PAIEMENT,
        variables: { id },
        refetchQueries: [{ query: GET_ORGANISMES_PAIEMENT }]
      });
      return data.removeOrganismePaiement;
    } catch (error) {
      console.error(`Delete organisme paiement ${id} error:`, error);
      throw error;
    }
  },

  setDefaultOrganisme: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: SET_DEFAULT_ORGANISME,
        variables: { id },
        refetchQueries: [{ query: GET_ORGANISMES_PAIEMENT }]
      });
      return data.setDefaultOrganisme;
    } catch (error) {
      console.error(`Set default organisme ${id} error:`, error);
      throw error;
    }
  }
};